import { Directive, ElementRef, EventEmitter, HostListener, Output, inject } from '@angular/core';

@Directive({
  selector: '[clickOutside]',
  standalone: false
})
export class ClickOutsideDirective {
  private elementRef = inject(ElementRef);

  @Output()
  public clickOutside = new EventEmitter();

  @HostListener('document:mousedown', ['$event.target'])
  public onMousedown(targetElement) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.clickOutside.emit(null);
    }
  }
}
